import Vue from "vue";
import AssetsLoad from "./AssetsLoad";
import { sleep } from "@js/utils";
let loadAsset = false;
function assetsLoad(next, cb, version) {
  if (loadAsset) {
    next();
    return;
  }
  const loadingVue = new Vue({
    render: (h) =>
      h(AssetsLoad, {
        props: {
          version,
        },
        on: {
          onCompleted() {
            loadAsset = true;
            loadingVue.$children[0].$destroy();
            let loadDom = document.querySelector("#loading");
            loadDom.className = loadDom.className + " leave"; // 执行退场动画
            if (Object.prototype.toString.call(cb) == "[object Function]") {
              cb();
            }
            setTimeout(async function () {
              loadDom.remove();
              next();
            }, 1000);
          },
        },
      }),
  }).$mount("#loading");
}

export default assetsLoad;
